module.exports = __webpack_public_path__ + "assets/mstile-144x144.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/mstile-144x144.png
// module id = 934
// module chunks = 17